"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3751],{

/***/ 49501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28525);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_BFormItem_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38086);
/* harmony import */ var styles_BFormItem_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styles_BFormItem_module_css__WEBPACK_IMPORTED_MODULE_4__);





var BTextArea = function(_param) {
    var className = _param.className, attrs = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_BFormItem_module_css__WEBPACK_IMPORTED_MODULE_4___default()["b-form-item"]), className)
    }, attrs));
};
/* harmony default export */ __webpack_exports__["Z"] = (BTextArea);


/***/ }),

/***/ 15010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Seo_SeoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(40686);
;// CONCATENATED MODULE: ./src/components/Seo/SeoContent.tsx

var SeoContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "seo-content prose prose-slate relative mx-auto w-full max-w-none",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var Seo_SeoContent = (SeoContent);

;// CONCATENATED MODULE: ./src/components/Seo/SeoWrapper.tsx







var SeoWrapper = function(param) {
    var children = param.children, helmetSettings = param.helmetSettings, content = param.content, additionalHeadElements = param.additionalHeadElements;
    var title = helmetSettings.title, script = helmetSettings.script, restHelmetSettings = (0,_object_without_properties/* default */.Z)(helmetSettings, [
        "title",
        "script"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, (0,_object_spread/* default */.Z)({}, restHelmetSettings)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    additionalHeadElements
                ]
            }),
            script ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: script
                }
            }) : null,
            children,
            content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo_SeoContent, {
                content: content
            }) : null
        ]
    });
};
/* harmony default export */ var Seo_SeoWrapper = (SeoWrapper);


/***/ }),

/***/ 84917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_BAlert; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/components/Icons/info.svg
var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5ZM3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1v-6a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M15.75 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var info = (SvgInfo);
;// CONCATENATED MODULE: ./src/components/common/BAlert.tsx



var BAlert = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, children = param.children, className = param.className, _hideIcon = param.hideIcon, hideIcon = _hideIcon === void 0 ? false : _hideIcon;
    var classesByVariant = {
        primary: "text-primary-700 bg-primary-100 border-primary-700",
        secondary: "text-slate-700 bg-slate-100 border-slate-700",
        success: "text-success-800 bg-success-100 border-success-800",
        danger: "text-danger-700 bg-danger-100 border-danger-700",
        warning: "text-warning-700 bg-warning-100 border-warning-700",
        info: "text-info-700 bg-info-100 border-info-700"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: classnames_default()("flex w-full items-center gap-2 rounded-md border px-4 py-2", className, classesByVariant[variant]),
        children: [
            hideIcon ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(info, {
                className: "w-6 flex-shrink-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var common_BAlert = (BAlert);


/***/ }),

/***/ 24800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80207);



var BBadge = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, children = param.children, className = param.className, _contrasted = param.contrasted, contrasted = _contrasted === void 0 ? false : _contrasted;
    var classesByVariant = {
        primary: "text-primary-900 bg-primary-100",
        secondary: "text-slate-900 bg-slate-100",
        success: "text-success-900 bg-success-100",
        danger: "text-danger-900 bg-danger-100",
        warning: "text-warning-900 bg-warning-100",
        info: "text-info-900 bg-info-100"
    };
    var contrastedClasses = {
        primary: "bg-primary-600 text-white",
        secondary: "bg-slate-600 text-white",
        success: "bg-success-600 text-white",
        danger: "bg-danger-600 text-white",
        warning: "bg-warning-600 text-white",
        info: "bg-info-600 text-white"
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_1__.cn)("inline-block rounded-full px-3 py-1.5 text-xs md:text-sm", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, classesByVariant[variant], !contrasted), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, contrastedClasses[variant], contrasted), _obj), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBadge);


/***/ }),

/***/ 95269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_CurrencyText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/hooks/useNumberFormat.ts
var useNumberFormat = __webpack_require__(58795);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./src/enums/currency.ts
var currency = __webpack_require__(85032);
// EXTERNAL MODULE: ./src/services/CookieService.ts
var CookieService = __webpack_require__(79925);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(15578);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(52500);
;// CONCATENATED MODULE: ./src/states/useCurrencyState.ts






var useCurrencyState = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set) {
    return {
        currency: CookieService/* cookieService.getCookie */._.getCookie("currency", {}) || currency/* Currency.TRY */.F.TRY,
        setCurrency: function(val) {
            return set(function(state) {
                CookieService/* cookieService.setCookie */._.setCookie("currency", val, {});
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    currency: val
                });
            });
        }
    };
}));

;// CONCATENATED MODULE: ./src/components/common/CurrencyText.tsx





var CurrencyText = /*#__PURE__*/ (0,react.memo)(function CurrencyText(param) {
    var price = param.price, propCurrency = param.currency, className = param.className;
    var ref = useCurrencyState(), stateCurrency = ref.currency;
    var priceFormat = (0,useNumberFormat/* useNumberFormat */.h)().priceFormat;
    var localizedPrice = priceFormat(price, propCurrency !== null && propCurrency !== void 0 ? propCurrency : stateCurrency);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()(className),
        children: localizedPrice
    });
});
/* harmony default export */ var common_CurrencyText = (CurrencyText);


/***/ }),

/***/ 30013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80207);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71016);




var ModalWithActivator = function(param) {
    var activator = param.activator, children = param.children, activatorClass = param.activatorClass, modalClass = param.modalClass, modalTitle = param.modalTitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: function() {
                    return setShow(true);
                },
                className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_2__.cn)("mx-auto w-max cursor-pointer", activatorClass),
                role: "presentation",
                children: activator
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                modalClass: modalClass,
                modalTitle: modalTitle,
                setShow: setShow,
                show: show,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWithActivator);


/***/ }),

/***/ 11455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10520);








var ResponsiveCarousel = function(param) {
    var className = param.className, children = param.children, _pagination = param.pagination, pagination = _pagination === void 0 ? false : _pagination, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? "auto" : _slidesPerView, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? undefined : _spaceBetween, _spacing = param.spacing, spacing = _spacing === void 0 ? "px-2" : _spacing, onSlideChange = param.onSlideChange;
    var modules = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(pagination ? [
        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
    ] : []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("responsive-carousel w-full", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
            modules: modules,
            pagination: pagination ? {
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 5
            } : false,
            spaceBetween: spaceBetween,
            slidesPerView: slidesPerView,
            onSlideChange: onSlideChange,
            children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto first:pl-0 last:pr-0", spacing),
                    children: child
                });
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveCarousel);


/***/ }),

/***/ 74950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ extraUnitTypeLabels; }
/* harmony export */ });
var extraUnitTypeLabels = {
    HEAD_COUNT: "common:units.headCount",
    HOUR: "common:units.hour",
    HOUR_RATE: "common:units.hour",
    RESERVATION: "common:units.reservation",
    DAY: "common:units.day",
    WEEK: "common:units.week"
};


/***/ }),

/***/ 85032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; }
/* harmony export */ });
var Currency;
(function(Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["TRY"] = "TRY";
})(Currency || (Currency = {}));


/***/ }),

/***/ 77997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ExtraUnitType; }
/* harmony export */ });
var ExtraUnitType;
(function(ExtraUnitType) {
    ExtraUnitType["HOUR"] = "HOUR";
    ExtraUnitType["RESERVATION"] = "RESERVATION";
    ExtraUnitType["HEAD_COUNT"] = "HEAD_COUNT";
    ExtraUnitType["HOUR_RATE"] = "HOUR_RATE";
    ExtraUnitType["DAY"] = "DAY";
    ExtraUnitType["WEEK"] = "WEEK";
})(ExtraUnitType || (ExtraUnitType = {}));


/***/ }),

/***/ 64588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ OfferState; }
/* harmony export */ });
var OfferState;
(function(OfferState) {
    OfferState["DENIED"] = "DENIED";
    OfferState["SUSPENDED"] = "SUSPENDED";
    OfferState["PULLED"] = "PULLED";
    OfferState["PENDING"] = "PENDING";
    OfferState["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    OfferState["ACCEPTED"] = "ACCEPTED";
    OfferState["EXPIRED"] = "EXPIRED";
})(OfferState || (OfferState = {}));


/***/ }),

/***/ 87644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SupportedDailyWeeklyRentalTypes; },
/* harmony export */   "a": function() { return /* binding */ SupportedHourlyRentalTypes; }
/* harmony export */ });
var SupportedHourlyRentalTypes;
(function(SupportedHourlyRentalTypes) {
    SupportedHourlyRentalTypes["HOURLY"] = "HOURLY";
    SupportedHourlyRentalTypes["SWIMMING_TOUR"] = "SWIMMING_TOUR";
})(SupportedHourlyRentalTypes || (SupportedHourlyRentalTypes = {}));
var SupportedDailyWeeklyRentalTypes;
(function(SupportedDailyWeeklyRentalTypes) {
    SupportedDailyWeeklyRentalTypes["WEEKLY"] = "WEEKLY";
    SupportedDailyWeeklyRentalTypes["DAILY"] = "DAILY";
    SupportedDailyWeeklyRentalTypes["HALF_DAY"] = "HALF_DAY";
})(SupportedDailyWeeklyRentalTypes || (SupportedDailyWeeklyRentalTypes = {}));


/***/ }),

/***/ 58795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useNumberFormat; }
/* harmony export */ });
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74021);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


function useNumberFormat() {
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__/* .useLocale */ .b)().locale;
    var numberLocaleFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(n) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2
        };
        return new Intl.NumberFormat(locale, options).format(n);
    }, [
        locale
    ]);
    var priceFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(price, currency) {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency
        }).format(price);
    }, [
        locale
    ]);
    return {
        numberLocaleFormat: numberLocaleFormat,
        priceFormat: priceFormat
    };
}


/***/ }),

/***/ 57441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ demandService; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(17407);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(80072);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36840);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(50132);
;// CONCATENATED MODULE: ./src/enums/demandState.ts
var DemandResponseState;
(function(DemandResponseState) {
    DemandResponseState["PENDING"] = "PENDING";
    DemandResponseState["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    DemandResponseState["COMPLETED"] = "COMPLETED";
    DemandResponseState["CANCELLED"] = "CANCELLED";
    DemandResponseState["DENIED"] = "DENIED";
    DemandResponseState["EXPIRED"] = "EXPIRED";
})(DemandResponseState || (DemandResponseState = {}));

// EXTERNAL MODULE: ./src/enums/extraUnitTypes.ts
var extraUnitTypes = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/enums/offerState.ts
var offerState = __webpack_require__(64588);
// EXTERNAL MODULE: ./src/types/demand.type.ts
var demand_type = __webpack_require__(91904);
// EXTERNAL MODULE: ./src/utils/axios.ts + 4 modules
var axios = __webpack_require__(38602);
// EXTERNAL MODULE: ./src/utils/ssrRequestFactory.ts + 2 modules
var ssrRequestFactory = __webpack_require__(32630);
// EXTERNAL MODULE: ./src/services/DateService.ts
var DateService = __webpack_require__(49163);
// EXTERNAL MODULE: ./src/enums/supportedRentalTypes.ts
var supportedRentalTypes = __webpack_require__(87644);
;// CONCATENATED MODULE: ./src/services/DemandService.ts















var DemandService = /*#__PURE__*/ function() {
    "use strict";
    function DemandService() {
        (0,_class_call_check/* default */.Z)(this, DemandService);
    }
    var _proto = DemandService.prototype;
    _proto.getUserDemandsSSR = function getUserDemandsSSR(ctx, hidePast) {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    (0,ssrRequestFactory/* ssrRequest */.e)("/v1/customer/demand", ctx, {
                        params: {
                            showOld: !hidePast
                        }
                    })
                ];
            });
        })();
    };
    _proto.getUserDemands = function getUserDemands(showOld) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.get */.Lp.get("/v1/customer/demand", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                                params: {
                                    showOld: showOld
                                }
                            }))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.getUserReservationsSSR = function getUserReservationsSSR(ctx, hidePast) {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    (0,ssrRequestFactory/* ssrRequest */.e)("/v1/customer/reservation", ctx, {
                        params: {
                            showOld: !hidePast
                        }
                    })
                ];
            });
        })();
    };
    _proto.getUserReservations = function getUserReservations(showOld) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.get */.Lp.get("/v1/customer/reservation", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                                params: {
                                    showOld: showOld
                                }
                            }))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.formatVehicleBasedDemandStateExtrasWithUnitType = function formatVehicleBasedDemandStateExtrasWithUnitType(selectedServices, selectedServicesUnits, services, numberOfPeople, duration, dwDurationType) {
        var weeklyCalculation = dwDurationType === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY ? duration : duration / 7;
        var _obj;
        var unitValues = (_obj = {}, (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.HEAD_COUNT */.q.HEAD_COUNT, numberOfPeople), (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.HOUR */.q.HOUR, duration), (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.HOUR_RATE */.q.HOUR_RATE, duration), (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.RESERVATION */.q.RESERVATION, 1), (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.DAY */.q.DAY, dwDurationType === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY ? duration * 7 : duration), (0,_define_property/* default */.Z)(_obj, extraUnitTypes/* ExtraUnitType.WEEK */.q.WEEK, Math.ceil(weeklyCalculation)), _obj);
        return selectedServices.reduce(function(acc, item) {
            var service = services.find(function(s) {
                return s.id === item;
            });
            if (service) {
                var _id;
                var itemUnit = (_id = selectedServicesUnits[service.id]) !== null && _id !== void 0 ? _id : unitValues[service.unit];
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, item, +itemUnit));
            }
            return acc;
        }, {});
    };
    _proto.formatVehicleBasedDemandStateToDemand = function formatVehicleBasedDemandStateToDemand(state, vehicleId, supportedExtras, paymentInfo) {
        var endDate = DateService/* dateService.formatDateToServer */.o.formatDateToServer(DateService/* dateService.resetMinuteBelow */.o.resetMinuteBelow(DateService/* dateService.getEndDateFromHourDuration */.o.getEndDateFromHourDuration(state.date, state.duration).toDate()));
        var selectedMeals = state.selectedMeal ? (0,_define_property/* default */.Z)({}, state.selectedMeal, +state.numberOfPeople) : {};
        var selectedExtras = (0,_to_consumable_array/* default */.Z)(state.selectedServices).concat((0,_to_consumable_array/* default */.Z)(state.selectedPackage ? [
            state.selectedPackage
        ] : []));
        var selectedExtrasUnit = (0,_object_spread/* default */.Z)({}, state.selectedServicesUnits, state.selectedPackagesUnits);
        var selectedServices = demandService.formatVehicleBasedDemandStateExtrasWithUnitType(selectedExtras, selectedExtrasUnit, supportedExtras, +state.numberOfPeople, +state.duration);
        var formattedPayload = {
            paymentInfo: paymentInfo,
            targetVehicleId: vehicleId,
            dateTimeRange: {
                startTime: DateService/* dateService.formatDateToServer */.o.formatDateToServer(DateService/* dateService.resetMinuteBelow */.o.resetMinuteBelow(state.date)),
                endTime: endDate
            },
            startHarborId: +state.harbor,
            finishHarborId: +state.endHarbor,
            hourlyVariant: state.isSwimmingTour ? supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR : supportedRentalTypes/* SupportedHourlyRentalTypes.HOURLY */.a.HOURLY,
            passengerCount: +state.numberOfPeople,
            selectedMeals: selectedMeals,
            selectedServices: selectedServices,
            platform: "WEB"
        };
        return formattedPayload;
    };
    _proto.formatVehicleBasedDWDemandStateToDemand = function formatVehicleBasedDWDemandStateToDemand(state, vehicleId, supportedExtras, paymentInfo, duration) {
        var selectedExtras = (0,_to_consumable_array/* default */.Z)(state.selectedServices);
        var selectedExtrasUnit = (0,_object_spread/* default */.Z)({}, state.selectedServicesUnits);
        var selectedServices = demandService.formatVehicleBasedDemandStateExtrasWithUnitType(selectedExtras, selectedExtrasUnit, supportedExtras, +state.numberOfPeople, duration || 0);
        return {
            paymentInfo: paymentInfo,
            targetVehicleId: vehicleId,
            dateTimeRange: {
                startTime: DateService/* dateService.formatDateToServer */.o.formatDateToServer(DateService/* dateService.resetMinuteBelow */.o.resetMinuteBelow(state.startDate)),
                endTime: DateService/* dateService.formatDateToServer */.o.formatDateToServer(DateService/* dateService.resetMinuteBelow */.o.resetMinuteBelow(state.endDate))
            },
            dwVariant: state.demandVariant,
            startHarborId: +state.harbor,
            finishHarborId: +state.endHarbor,
            passengerCount: +state.numberOfPeople,
            selectedMeals: {},
            selectedServices: selectedServices,
            platform: "WEB"
        };
    };
    _proto.createDemand = function createDemand(payload, options) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.post */.Lp.post("/v1/customer/demand", payload, (0,_object_spread/* default */.Z)({
                                hideError: true
                            }, options || {}))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.updateDemand = function updateDemand(demandId, payload, options) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.put */.Lp.put("/v1/customer/demand/".concat(demandId), payload, (0,_object_spread/* default */.Z)({
                                hideError: true
                            }, options || {}))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.calculatePricing = function calculatePricing(payload) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data, mealPrice, extraPrice;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.post */.Lp.post("/v1/customer/demand/calculate-pricing", payload)
                        ];
                    case 1:
                        data = _state.sent().data;
                        mealPrice = data.mealPricings.reduce(function(acc, val) {
                            return acc + val.value;
                        }, 0);
                        extraPrice = data.servicePricings.reduce(function(acc, val) {
                            return acc + val.value;
                        }, 0);
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                mealPrice: mealPrice,
                                extraPrice: extraPrice
                            })
                        ];
                }
            });
        })();
    };
    _proto.checkAvailableTenderVehicles = function checkAvailableTenderVehicles(payload) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.post */.Lp.post("/v1/customer/demand/available-vehicles", payload, {
                                hideError: true
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.formatVehicle = function formatVehicle(vehicle) {
        return {
            id: vehicle.id,
            commentCount: vehicle.rating.vehicleAverage.commentCount,
            rating: vehicle.rating.vehicleAverage.overallAverage,
            images: vehicle.images,
            type: vehicle.type,
            vehiclePrioritizedConditions: vehicle.usageConditions.map(function(cond) {
                return cond.label;
            }),
            brand: vehicle.brandName,
            length: vehicle.vehicleLength,
            businessModel: vehicle.businessModel
        };
    };
    _proto.formatExtra = function formatExtra(extra) {
        var ref;
        var ref1;
        return {
            name: extra.title,
            count: extra.count,
            price: extra === null || extra === void 0 ? void 0 : (ref = extra.price) === null || ref === void 0 ? void 0 : ref.amount,
            unit: (ref1 = extra === null || extra === void 0 ? void 0 : extra.unit) !== null && ref1 !== void 0 ? ref1 : extraUnitTypes/* ExtraUnitType.HEAD_COUNT */.q.HEAD_COUNT
        };
    };
    _proto.formatOffer = function formatOffer(offer) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var isTimeSuggested = !!offer.suggestedDateTimeRange;
        return {
            id: offer.id,
            isTimeSuggested: isTimeSuggested,
            startDate: ((ref = offer.suggestedDateTimeRange) === null || ref === void 0 ? void 0 : ref.startTime) ? DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate((ref1 = offer.suggestedDateTimeRange) === null || ref1 === void 0 ? void 0 : ref1.startTime) : null,
            endDate: ((ref2 = offer.suggestedDateTimeRange) === null || ref2 === void 0 ? void 0 : ref2.endTime) ? DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate((ref3 = offer.suggestedDateTimeRange) === null || ref3 === void 0 ? void 0 : ref3.endTime) : null,
            currency: (ref4 = offer.paymentInfo) === null || ref4 === void 0 ? void 0 : ref4.currency,
            prepaymentPrice: (ref5 = offer.paymentInfo) === null || ref5 === void 0 ? void 0 : ref5.prePaymentAmount,
            totalPrice: (ref6 = offer.paymentInfo) === null || ref6 === void 0 ? void 0 : ref6.totalAmount,
            priceToPayOnBoard: (ref7 = offer.paymentInfo) === null || ref7 === void 0 ? void 0 : ref7.priceToPayOnBoard,
            vehicle: demandService.formatVehicle(offer.vehicle),
            paymentInfo: offer.paymentInfo
        };
    };
    _proto.formatDemand = function formatDemand(response) {
        var demandType = response.demand.organization ? demand_type/* DemandType.TENDER */.cZ.TENDER : demand_type/* DemandType.AVAILABILITY */.cZ.AVAILABILITY;
        var startDate = response.demand.startTime;
        var endDate = response.demand.endTime;
        var services = response.demand.services.map(demandService.formatExtra);
        var meals = response.demand.meals.map(demandService.formatExtra);
        var packages = response.demand.packages.map(demandService.formatExtra);
        var badgeState = response.demand.state === "DENIED" ? demand_type/* DemandState.DENIED */.ec.DENIED : response.demand.badgeState;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: response.demand.id,
            demandType: demandType,
            dwVariant: response.demand.dwVariant,
            hourlyVariant: response.demand.hourlyVariant,
            state: badgeState,
            organization: response.demand.organization,
            organizationTRName: response.demand.organizationTRName,
            numberOfPeople: response.demand.passengerCount,
            creationDate: DateService/* dateService.formatServerUTCToLocal */.o.formatServerUTCToLocal(response.demand.createdAt),
            startDate: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(startDate),
            endDate: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(endDate),
            harbor: response.demand.startHarbor,
            endHarbor: response.demand.finishHarbor,
            region: response.demand.region,
            regionTRName: response.demand.regionTRName
        }, response.demand.targetVehicle ? {
            vehicle: demandService.formatVehicle(response.demand.targetVehicle)
        } : {}), {
            extras: {
                meals: meals,
                packages: packages,
                services: services
            },
            paymentInfo: response.demand.paymentInfo,
            offer: response.offers.filter(function(offer) {
                var isDemandOngoing = [
                    DemandResponseState.PENDING,
                    DemandResponseState.PAYMENT_PENDING, 
                ].includes(response.demand.state);
                if (isDemandOngoing) {
                    return offer.state !== offerState/* OfferState.PULLED */.V.PULLED;
                }
                return true;
            }).map(demandService.formatOffer)
        });
    };
    _proto.formatReservationState = function formatReservationState(state) {
        if (state === demand_type/* ReservationState.DONE */.hM.DONE) {
            return demand_type/* DemandState.COMPLETED */.ec.COMPLETED;
        }
        if (state === demand_type/* ReservationState.CANCELLED */.hM.CANCELLED) {
            return demand_type/* DemandState.CANCELLED */.ec.CANCELLED;
        }
        return demand_type/* DemandState.WAITING */.ec.WAITING;
    };
    _proto.formatReservation = function formatReservation(response) {
        var demandType = demand_type/* DemandType.RESERVATION */.cZ.RESERVATION;
        var isTimeSuggested = !!response.offer.suggestedDateTimeRange;
        var startDate = isTimeSuggested ? response.offer.suggestedDateTimeRange.startTime : response.reservation.startTime;
        var endDate = isTimeSuggested ? response.offer.suggestedDateTimeRange.endTime : response.reservation.endTime;
        var services = response.reservation.services.map(demandService.formatExtra);
        var meals = response.reservation.meals.map(demandService.formatExtra);
        var packages = response.reservation.packages.map(demandService.formatExtra);
        var badgeState = demandService.formatReservationState(response.reservation.state);
        return {
            id: response.reservation.id,
            contactInfo: badgeState === demand_type/* DemandState.WAITING */.ec.WAITING ? response.reservation.contactInfo : undefined,
            demandType: demandType,
            ratingDone: response.reservation.ratingDone,
            hourlyVariant: response.reservation.hourlyVariant,
            dwVariant: response.reservation.dwVariant,
            state: badgeState,
            organization: response.reservation.organization,
            organizationTRName: response.reservation.organizationTRName,
            numberOfPeople: response.reservation.passengerCount,
            creationDate: DateService/* dateService.formatServerUTCToLocal */.o.formatServerUTCToLocal(response.reservation.createdAt),
            startDate: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(startDate),
            endDate: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(endDate),
            harbor: response.reservation.startHarbor,
            endHarbor: response.reservation.finishHarbor,
            region: response.reservation.region,
            regionTRName: response.reservation.regionTRName,
            extras: {
                meals: meals,
                packages: packages,
                services: services
            },
            freeCancellable: response.reservation.freeCancellable,
            offer: [
                demandService.formatOffer(response.offer)
            ]
        };
    };
    _proto.acceptOffer = function acceptOffer(demandId, offerId) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.post */.Lp.post("/v1/customer/demand/".concat(demandId, "/offers/").concat(offerId, "/accept"))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.cancelDemand = function cancelDemand(demandId, cancelReason) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.put */.Lp.put("/v2/customer/demand/".concat(demandId, "/delete"), {
                                reason: cancelReason
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.cancelReservation = function cancelReservation(reservationId, cancelReason) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.put */.Lp.put("/v2/customer/reservation/".concat(reservationId, "/delete"), {
                                reason: cancelReason
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    return DemandService;
}();
var demandService = new DemandService();


/***/ }),

/***/ 91904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cZ": function() { return /* binding */ DemandType; },
/* harmony export */   "ec": function() { return /* binding */ DemandState; },
/* harmony export */   "hM": function() { return /* binding */ ReservationState; }
/* harmony export */ });
var DemandState;
(function(DemandState) {
    DemandState["RESPONDED_AVAILABILITY"] = "RESPONDED_AVAILABILITY";
    DemandState["RESPONDED_TENDER"] = "RESPONDED_TENDER";
    DemandState["RESPONDED_NEW_DATE"] = "RESPONDED_NEW_DATE";
    DemandState["CANCELLED"] = "CANCELLED";
    DemandState["NOT_RESPONDED"] = "NOT_RESPONDED";
    DemandState["WAITING"] = "WAITING";
    DemandState["COMPLETED"] = "COMPLETED";
    DemandState["EXPIRED"] = "EXPIRED";
    DemandState["DENIED"] = "DENIED";
})(DemandState || (DemandState = {}));
var DemandType;
(function(DemandType) {
    DemandType["TENDER"] = "TENDER";
    DemandType["AVAILABILITY"] = "AVAILABILITY";
    DemandType["RESERVATION"] = "RESERVATION";
})(DemandType || (DemandType = {}));
var ReservationState;
(function(ReservationState) {
    ReservationState["PRE_PAYMENT_PENDING"] = "PRE_PAYMENT_PENDING";
    ReservationState["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    ReservationState["CANCELLED"] = "CANCELLED";
    ReservationState["ON_GOING"] = "ON_GOING";
    ReservationState["WAITING_DUE_DATE"] = "WAITING_DUE_DATE";
    ReservationState["DONE"] = "DONE";
})(ReservationState || (ReservationState = {}));


/***/ }),

/***/ 8014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getDWDuration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80072);
/* harmony import */ var enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87644);
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49163);



var _obj;
var unitToDurationFormatter = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDailyWeeklyRentalTypes.DAILY */ .N.DAILY, function(startDate, endDate) {
    return Math.ceil(services_DateService__WEBPACK_IMPORTED_MODULE_1__/* .dateService.getDayDuration */ .o.getDayDuration(startDate, endDate));
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDailyWeeklyRentalTypes.HALF_DAY */ .N.HALF_DAY, function(startDate, endDate) {
    return Math.ceil(services_DateService__WEBPACK_IMPORTED_MODULE_1__/* .dateService.getDayDuration */ .o.getDayDuration(startDate, endDate)) + 1;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDailyWeeklyRentalTypes.WEEKLY */ .N.WEEKLY, function(startDate, endDate) {
    return Math.ceil(services_DateService__WEBPACK_IMPORTED_MODULE_1__/* .dateService.getWeekDuration */ .o.getWeekDuration(startDate, endDate));
}), _obj);
var getDWDuration = function(startDate, endDate, demandVariant) {
    return unitToDurationFormatter[demandVariant](startDate, endDate);
};


/***/ })

}]);